var makeLink = function (req) {
  return process.env.VUE_APP_BACKEND_URL + '/api' + req + '?authToken=' + localStorage.getItem('id_token')
}

export default makeLink
